import React from 'react';
import { Image, Text } from 'rebass/styled-components';
import RecipeIndicatorBase, { conversionTable } from './RecipeIndicatorBase';

const RecipeAllergenIndicator = ({ allergen, containerStyle }:{allergen: string, containerStyle: React.CSSProperties}) => {
  const al = conversionTable.find((x) => x.allergen === allergen);
  if(!al) return null
  return (
    <RecipeIndicatorBase indicatorValue={<Image src={al.image} height={22} width={22} style={{ height: 48, width: 48 }} />}>
      <Text fontWeight={300} textAlign='center' style={{wordBreak: 'break-word', fontSize: '12px'}}>{allergen}</Text>
    </RecipeIndicatorBase>
  );
};

export default RecipeAllergenIndicator;
